import { IRequest } from '@r1-frontend/shared/types/IRequest';

export type { ICreditCondition } from './dto/ResponseDto';
/**
 * Получение условий по кредиту
 * https://master.payments.sandbox.d2c.r-one.io/docs#/Credits/CreditsController_getCondition
 * @returns ICreditCondition[]
 */
export const condition = (loanSum: number): IRequest => ({
    uri: '/api/v1/credits/condition',
    method: 'GET',
    withProvider: true,
    withAuth: true,
    queryParams: {
        loanSum,
    },
});
